import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { makeStyles } from "@material-ui/core/styles";
import iconDocTpl from "../../../../Assets/templateV2/doc_tpl.svg";

const defaultOptionsMenu = [
	{
		label: "Shipping",
		value: "Shipping",
		icon: <LocalShippingIcon />,
	},
	{
		label: "Send",
		value: "Send",
		icon: <CloudUploadIcon />,
	},
	{
		label: "Edit Template",
		value: "EditTemplate",
		icon: <EditIcon />,
	},
	{
		label: "Delete",
		value: "Delete",
		icon: <DeleteIcon />,
	},
];

const useStyles = makeStyles((theme) => ({
	container: {
		width: 120,
		height: 130,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		position: "relative",
		padding: "10px 10px 0 10px",
		boxSizing: "border-box",
	},
	icon: {
		fontSize: 40,
		color: theme.palette.primary.main,
	},
	title: {
		textAlign: "center",
		color: theme.palette.primary.main,
		width: "100%",
		minHeight: "auto",
		maxHeight: 24,
		margin: 0,
		padding: 0,
		fontSize: 11,
		fontWeight: "normal",
		lineHeight: 1.2,
		textOverflow: "ellipsis",
		overflow: "hidden",
		display: "-webkit-box",
		"-webkit-line-clamp": 2,
		"-webkit-box-orient": "vertical",
		wordBreak: "break-word",
	},
	cardContent: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		position: "relative",
	},
	moreIconBtn: {
		width: "auto",
		height: "auto",
		position: "absolute",
		top: 5,
		right: 5,
		padding: 0,
		backgroundColor: "transparent",
		border: "none",
		cursor: "pointer",
	},
	menu: {
		backgroundColor: "#fff",
		borderWidth: 0,
		borderColor: "transparent",
	},
	itemMenu: {
		display: "flex",
		alignItems: "center",
		color: theme.palette.primary.main,
		cursor: "pointer",
		justifyContent: "flex-start",
		alignItems: "center",
		padding: "10px",
		gap: "10px",
		borderRadius: "5px",
		transition: "background-color 0.3s ease",
		"&:hover": {	
			backgroundColor: "#f0f0f0",
		},
	},
	menuItemText: {
		marginLeft: "10px",
		color: "#0D0D0D",
	},
	iconFile: {
		width: 60,
		height: 76,
	},
}));


export default function TemplateCard({
	template,
	onClickMenu,
	optionsMenu = defaultOptionsMenu,
	docIcon = iconDocTpl,
}) {
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = (menu, template) => {
		console.log("menu", menu);
		setAnchorEl(null);
		onClickMenu(menu, template);
	};

	const open = Boolean(anchorEl);

	return (
		<div className={classes.container} variant="outlined">
			<button
				className={classes.moreIconBtn}
				aria-controls="simple-menu"
				aria-haspopup="true"
				onClick={handleMenuOpen}
			>
				<MoreVertIcon />
			</button>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleMenuClose}
				color="primary"
			>
				{optionsMenu.map((option) => (
					<MenuItem
						className={classes.itemMenu}
						key={option.value}
						onClick={() => handleMenuClose(option.value, template)}
					>
						{option.icon}
						<span className={classes.menuItemText}>{option.label}</span>
					</MenuItem>
				))}
			</Menu>
			<div className={classes.cardContent}>
				<div>
					<img src={docIcon} alt="iconDocTpl" className={classes.iconFile} />
				</div>
				<span variant="subtitle1" className={classes.title}>
					{template.templateName}
				</span>
			</div>
		</div>
	);
}
